import { render, staticRenderFns } from "./regNPayForm.vue?vue&type=template&id=3077b208&"
import script from "./regNPayForm.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./regNPayForm.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./regNPayForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports